import { pageInfo } from './../api';
import { Message } from 'element-ui';
const logDetail = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    addResp: null,
    editResp: null,
    deleteResp: null,
    initPageObj: null,
    initUpdateObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    SELECT_CARRIER_DATA(state, data) {
      state.selectCarrierObj = data.obj || {};
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({ commit, rootGetters }, obj) {
      let resp = await pageInfo(obj);
      if (resp.code === rootGetters.successCode) {
        Message({ showClose: true, message: resp.msg, type: 'success' });
      }
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({ commit }, obj) {
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initUpdate({ commit }, obj) {
      let resp = await initUpdate(obj);
      commit('INIT_UPDATE', resp);
    },
  }
}
export default logDetail



// WEBPACK FOOTER //
// ./src/page/int/logDetail/store/logDetail.store.js